import hubspotCssUrl from '../styles/hubspot-cookies.css?url';

export const loadHubspotCMP = () => {
  const enabled = import.meta.env.VITE_APP_ENABLE_HUBSPOT_COOKIES === 'true';
  if (!enabled) return;

  if (document.getElementById('hs-script-loader')) return;

  const script = document.createElement('script');
  script.id = 'hs-script-loader';
  script.async = true;
  script.defer = true;
  script.src = '//js.hs-scripts.com/7525458.js';

  script.onload = () => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = hubspotCssUrl;
    document.head.appendChild(link);
  };

  document.body.appendChild(script);
};
